<template>
  <AutoComplete
      v-model="internalModel"
      :suggestions="filteredEquipments"
      @complete="searchEquipment"
      @item-select="onItemSelect"
      @clear="onItemClear"
      @item-unselect="onItemUnselect"
      :forceSelection="forceSelection"
      field="serial_number"
      :minLength=3
      :disabled="disabled"
  >
    <template #item="{ item, index }">
      <div class="autocomplete-row">
        <div class="autocomplete-serial-number" :title="item.serial_number">
          {{ item.serial_number }}
        </div>
        <div class="autocomplete-product-code" :title="item.product_code">{{ item.product_code }}</div>
        <div class="autocomplete-name" :title="item.name">{{ item.name }}</div>
      </div>
    </template>
  </AutoComplete>
</template>

<script>


export default {
  props: {
    value: {
      type: [Object, String],
      default: () => {
        return ""
      }
    },
    forceSelection: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    internalModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (typeof newValue === 'string' && !this.isEquipmentInList(newValue)) {
          const customValue = {equipment_id: null, serial_number: newValue};
          this.$emit('input', customValue);
        } else {
          this.$emit('input', newValue);
        }
      }
    }
  },
  data() {
    return {
      filteredEquipments: [],
    };
  },
  methods: {
    async searchEquipment(event) {
      if (!event.query.trim()) return;

      try {
        const queryParams = this.buildQueryParams(event.query);
        const response = await this.EquipmentService.getEquipment({filterOptions: queryParams});
        this.filteredEquipments = response;
      } catch (error) {
        console.error("Error fetching equipment:", error);
      }
    },
    buildQueryParams(searchTerm) {
      return {
        searchTerm,
        noPaging: "True",
        select: 'product_code, equipment_id, description, product_type, name, serial_number '
      };
    },
    isEquipmentInList(name) {

      // return this.filteredEquipments.some(equipment => equipment.name === name);
    },
    onItemSelect(event) {
      this.$emit('equipmentSelected', event);
    },
    onItemClear(event) {
      this.$emit('equipmentCleared', event);
    },
    onItemUnselect(event) {
      this.$emit('equipmentUnselected', event);
    },
  }
};
</script>

<style>
.autocomplete-row {
  display: flex;
  justify-content: space-between;
}

.autocomplete-name,
.autocomplete-product-code,
.autocomplete-serial-number {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 2px;
}

.autocomplete-serial-number {
  width: 30%;

}

.autocomplete-product-code {
  width: 20%;
}

.autocomplete-name {
  width: 50%;
}

.p-autocomplete-panel {
  max-width: 100%;
  width: auto;
}

.p-autocomplete-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.test-p-autocomplete-panel {
  width: calc(100% * 2) !important;
  max-width: calc(100% * 2) !important;
}
</style>
